import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

/**
 * This function returns the translation key for the given calculation member source.
 * @param source
 * @returns The translation key for the given calculation member source.
 */
export function getMemberSourceTranslationKey(
	source: Enums<"serviceCalculationMemberSource">,
): TranslationKey {
	switch (source) {
		case "offer-match":
			return "calculations.member_source_offer_match";
		case "manual":
			return "calculations.member_source_manual";
	}
}
